/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkInProgressLine } from './WorkInProgressLine';
import {
    WorkInProgressLineFromJSON,
    WorkInProgressLineFromJSONTyped,
    WorkInProgressLineToJSON,
} from './WorkInProgressLine';

/**
 * 
 * @export
 * @interface WorkInProgress
 */
export interface WorkInProgress {
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    customerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    roId: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    roNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    vehicle: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    insuranceCompany?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    estimator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    preScan?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    vin: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgress
     */
    total?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    productionStatus?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkInProgress
     */
    completedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkInProgress
     */
    requestSubmitted?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    requestType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    rescheduleRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    adasRecommendation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    vehicleYear: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    vehicleMake: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    vehicleModel: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    licensePlateNum: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    licensePlateState: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    interiorColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    exteriorColor?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgress
     */
    odometer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    condition?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgress
     */
    bodyRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkInProgress
     */
    mechanicalRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkInProgress
     */
    claimNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkInProgress
     */
    lossDate?: Date | null;
    /**
     * 
     * @type {Array<WorkInProgressLine>}
     * @memberof WorkInProgress
     */
    lines?: Array<WorkInProgressLine> | null;
}

/**
 * Check if a given object implements the WorkInProgress interface.
 */
export function instanceOfWorkInProgress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "customerId" in value;
    isInstance = isInstance && "roId" in value;
    isInstance = isInstance && "roNumber" in value;
    isInstance = isInstance && "vehicle" in value;
    isInstance = isInstance && "vin" in value;
    isInstance = isInstance && "vehicleYear" in value;
    isInstance = isInstance && "vehicleMake" in value;
    isInstance = isInstance && "vehicleModel" in value;
    isInstance = isInstance && "licensePlateNum" in value;
    isInstance = isInstance && "licensePlateState" in value;

    return isInstance;
}

export function WorkInProgressFromJSON(json: any): WorkInProgress {
    return WorkInProgressFromJSONTyped(json, false);
}

export function WorkInProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkInProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerId': json['customerId'],
        'roId': json['roId'],
        'roNumber': json['roNumber'],
        'vehicle': json['vehicle'],
        'insuranceCompany': !exists(json, 'insuranceCompany') ? undefined : json['insuranceCompany'],
        'estimator': !exists(json, 'estimator') ? undefined : json['estimator'],
        'preScan': !exists(json, 'preScan') ? undefined : json['preScan'],
        'vin': json['vin'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'productionStatus': !exists(json, 'productionStatus') ? undefined : json['productionStatus'],
        'completedDate': !exists(json, 'completedDate') ? undefined : (json['completedDate'] === null ? null : new Date(json['completedDate'])),
        'requestSubmitted': !exists(json, 'requestSubmitted') ? undefined : (json['requestSubmitted'] === null ? null : new Date(json['requestSubmitted'])),
        'requestType': !exists(json, 'requestType') ? undefined : json['requestType'],
        'rescheduleRequest': !exists(json, 'rescheduleRequest') ? undefined : json['rescheduleRequest'],
        'adasRecommendation': !exists(json, 'adasRecommendation') ? undefined : json['adasRecommendation'],
        'vehicleYear': json['vehicleYear'],
        'vehicleMake': json['vehicleMake'],
        'vehicleModel': json['vehicleModel'],
        'licensePlateNum': json['licensePlateNum'],
        'licensePlateState': json['licensePlateState'],
        'interiorColor': !exists(json, 'interiorColor') ? undefined : json['interiorColor'],
        'exteriorColor': !exists(json, 'exteriorColor') ? undefined : json['exteriorColor'],
        'odometer': !exists(json, 'odometer') ? undefined : json['odometer'],
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'bodyRate': !exists(json, 'bodyRate') ? undefined : json['bodyRate'],
        'mechanicalRate': !exists(json, 'mechanicalRate') ? undefined : json['mechanicalRate'],
        'claimNumber': !exists(json, 'claimNumber') ? undefined : json['claimNumber'],
        'lossDate': !exists(json, 'lossDate') ? undefined : (json['lossDate'] === null ? null : new Date(json['lossDate'])),
        'lines': !exists(json, 'lines') ? undefined : (json['lines'] === null ? null : (json['lines'] as Array<any>).map(WorkInProgressLineFromJSON)),
    };
}

export function WorkInProgressToJSON(value?: WorkInProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customerId': value.customerId,
        'roId': value.roId,
        'roNumber': value.roNumber,
        'vehicle': value.vehicle,
        'insuranceCompany': value.insuranceCompany,
        'estimator': value.estimator,
        'preScan': value.preScan,
        'vin': value.vin,
        'total': value.total,
        'productionStatus': value.productionStatus,
        'completedDate': value.completedDate === undefined ? undefined : (value.completedDate === null ? null : value.completedDate.toISOString()),
        'requestSubmitted': value.requestSubmitted === undefined ? undefined : (value.requestSubmitted === null ? null : value.requestSubmitted.toISOString()),
        'requestType': value.requestType,
        'rescheduleRequest': value.rescheduleRequest,
        'adasRecommendation': value.adasRecommendation,
        'vehicleYear': value.vehicleYear,
        'vehicleMake': value.vehicleMake,
        'vehicleModel': value.vehicleModel,
        'licensePlateNum': value.licensePlateNum,
        'licensePlateState': value.licensePlateState,
        'interiorColor': value.interiorColor,
        'exteriorColor': value.exteriorColor,
        'odometer': value.odometer,
        'condition': value.condition,
        'bodyRate': value.bodyRate,
        'mechanicalRate': value.mechanicalRate,
        'claimNumber': value.claimNumber,
        'lossDate': value.lossDate === undefined ? undefined : (value.lossDate === null ? null : value.lossDate.toISOString()),
        'lines': value.lines === undefined ? undefined : (value.lines === null ? null : (value.lines as Array<any>).map(WorkInProgressLineToJSON)),
    };
}

